export const MAIN_NAV_TRACK = {
    EVENT: 'e_mainNav',
    EVENT_WAFFLE_NAV: 'e_waffleNav',
    LOGO_CLICK_TEXT: 'Logo Click',
    TOP_MENU_CONTEXT: 'Top Menu',
    ALL_CATEGORIES_TEXT: 'All Categories',
    SHOP: 'Shop',
    TOP_SUBMENU_CONTEXT: 'Top Sub Menu',
    BUYING_OPTIONS_TOP_SUBMENU_CONTEXT: 'Buying Options - top sub menu',    
    MY_EQUIPMENT: 'My Equipment',
    CONTROL_CENTER: 'Control Center',
    ORDER_HISTORY: 'Order History',
    HELP_CENTER_TEXT: 'Help Center',
    SHOP_ALL_CATEGORIES: 'Shop all categories',
    MY_ACCOUNT_DRAWER_TEXT: 'My Account Drawer',
    STORE_INFORMATION_DRAWER_TEXT: 'Store Information Drawer',
    SHOPPING_CART_TEXT:'Shopping Cart',
    WAFFLE_TEXT: 'Waffle',
    SELECT_EQUIPMENT_TEXT: 'Select Equipment',
    CURRENTLY_SHOPPING_DRAWER_TEXT: 'Currently Shopping Drawer'
  };